import {
  BezierEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getBezierPath,
} from "reactflow";
import { useFlow } from "../FlowEdit/useFlow";
import { ModuleOutputKeyEnum } from "@packages/flow-core/module";
import { ArrowRightOutlined, CloseCircleFilled } from "@ant-design/icons";
import { Row } from "antd";
import { CSSProperties, useMemo } from "react";

export default function ButtonEdge(props: EdgeProps) {
  const { getAllNodes, delEdge } = useFlow();
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    selected,
    sourceHandleId,
    style = {},
  } = props;

  const active = (() => {
    const connectNode = getAllNodes().find((node) => {
      return (
        (node.id === props.source || node.id === props.target) && node.selected
      );
    });
    return !!(connectNode || selected);
  })();

  const [, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const isToolEdge = sourceHandleId === ModuleOutputKeyEnum.selectedTools;

  const memoEdgeLabel = useMemo(() => {
    return (
      <EdgeLabelRenderer>
        <Row
          align="middle"
          justify="center"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            position: "absolute",
            zIndex: active ? 1000 : 0,
            width: 20,
            height: 20,
            background: "#F5F5F5",
            pointerEvents: "all",
          }}
        >
          <CloseCircleFilled
            style={{ color: active ? "#dbbe96" : "#BBBFC4", fontSize: 20 }}
            onClick={() => {
              delEdge(id);
            }}
          />
        </Row>
        {!isToolEdge && (
          <Row
            align="middle"
            justify="center"
            style={{
              transform: `translate(-50%, -50%) translate(${
                targetX - 8
              }px,${targetY}px)`,
              width: 16,
              height: 16,
              background: "#F5F5F5",
              zIndex: active ? 1000 : 0,
              position: "absolute",
            }}
          >
            <ArrowRightOutlined
              style={{ color: active ? "#dbbe96" : "#BBBFC4" }}
            />
          </Row>
        )}
      </EdgeLabelRenderer>
    );
  }, [labelX, labelY, active, isToolEdge, targetX, targetY, id]);

  const memoBezierEdge = useMemo(() => {
    const edgeStyle: CSSProperties = {
      ...style,
      ...(active
        ? {
            strokeWidth: 3,
            stroke: "#dbbe96",
          }
        : { strokeWidth: 2, zIndex: 2, stroke: "#BBBFC4" }),
    };

    return <BezierEdge {...props} style={edgeStyle as any} />;
  }, [style, active, props]);

  return (
    <>
      {memoBezierEdge}
      {memoEdgeLabel}
    </>
  );
}
